export default __webpack_public_path__ + "static/media/landing-footer-bg-icon-1.1acfc72d.svg";